export default __webpack_public_path__ + "static/media/lock2.801d6e09.svg";